<template>
  <div class="about container">
    <page-header
      v-if="banner"
      color="white"
      type="image"
      :image="banner"
      :height="1080"
    >
    </page-header>

    <div class="mainbox">
      Lorem ipsum, dolor sit amet consectetur adipisicing elit. Omnis placeat
      maiores, sed officia possimus optio enim recusandae beatae architecto
      culpa maxime non, repellat ullam suscipit reprehenderit pariatur magnam
      exercitationem similique cupiditate fugit quos iste soluta magni incidunt.
      Ad, temporibus. Ipsum quam doloribus inventore dolorem debitis velit odio?
      Mollitia, aliquid neque! Beatae ipsum nemo suscipit labore, sit porro eos
      consequuntur, corrupti dolorum quo commodi voluptate. Repudiandae minus at
      rerum exercitationem blanditiis nesciunt? Facere aliquid expedita quas
      nostrum! Sapiente exercitationem vitae qui, aspernatur quidem obcaecati
      numquam quam velit ea esse modi saepe doloremque ullam? Totam iure aperiam
      modi aut maiores, quos doloribus dicta. Nisi earum dolore illum, quas
      dolor odit iste delectus eaque aut dolores obcaecati dolorem ad amet at
      commodi! Distinctio, temporibus illum, culpa suscipit cumque, totam at
      laboriosam delectus necessitatibus numquam obcaecati! Incidunt nemo soluta
      expedita. Totam, itaque fugiat commodi sed quidem quas amet eligendi ullam
      odit similique earum iste aliquam neque ipsam exercitationem perspiciatis.
      Consequuntur excepturi sunt mollitia, ullam ut aperiam eaque expedita
      minus alias adipisci nisi. Quisquam odit id excepturi illo quasi magnam,
      repudiandae fuga ullam impedit! Assumenda dolorum reiciendis perspiciatis
      provident fugiat inventore minima nisi temporibus cum. Quis natus magnam
      id nihil debitis deleniti? Iusto quidem iste provident minima, et atque
      maiores nulla, itaque eligendi praesentium eaque. Maiores eveniet incidunt
      quod eligendi, laudantium nemo, nesciunt sint rem eaque iusto ratione
      ducimus possimus hic pariatur nisi sapiente facere quasi libero suscipit
      voluptate quos error nulla. Perferendis sapiente quibusdam natus aliquam
      temporibus iusto provident, amet animi excepturi enim esse suscipit
      corrupti. Libero, facere? Possimus esse id dolorem temporibus vel error
      nam, est ducimus voluptatum consectetur veritatis eligendi tenetur vero et
      ut ex veniam quod. Dignissimos excepturi debitis porro maxime, pariatur
      suscipit consequatur. Vero nam blanditiis eveniet sit amet illum,
      voluptatum esse perspiciatis? Repellat sunt rem provident est, dignissimos
      assumenda doloremque nobis ea quas, id, suscipit voluptatem culpa.
      Voluptatibus rem, aspernatur accusamus fugiat, exercitationem dignissimos
      eius similique eveniet ea temporibus inventore incidunt nisi cum mollitia
      est, quos nulla? Mollitia sint ratione placeat officiis fugiat architecto
      hic quasi eligendi doloremque aut. Iure quam atque quos autem nisi nam
      alias magni. Nesciunt inventore veniam facilis hic qui labore corporis eos
      recusandae, dicta odit similique vero quos animi illo, dolorum quibusdam,
      repellendus ullam magni at optio nostrum dolor assumenda ex excepturi.
      Exercitationem, non? Numquam recusandae doloribus repellat, ea
      voluptatibus est maiores veritatis incidunt rem ducimus unde blanditiis
      iste cupiditate fugiat eum porro facilis, alias at fuga exercitationem.
      Quam impedit dignissimos laudantium molestias sunt, perferendis, atque
      earum, libero facere dolore ea. Et reiciendis sunt accusamus alias
      pariatur beatae, voluptatem repellendus quibusdam, illum fugit aliquam, a
      optio obcaecati blanditiis! Quibusdam, ratione dolore neque praesentium
      corrupti iste modi odit perspiciatis pariatur optio illo maiores
      voluptatem labore reprehenderit consequatur reiciendis iusto possimus quos
      eius vel placeat aliquid nulla laudantium officiis. Ipsa temporibus
      voluptates veniam dignissimos reprehenderit? Placeat sint earum officia
      laboriosam porro cum facilis iste, laudantium, pariatur sapiente dicta
      autem voluptatem possimus voluptatum iusto perferendis ut neque magnam
      quidem explicabo. Quia temporibus tempore fugiat fuga porro nam veritatis
      molestias ex blanditiis quae itaque maiores dignissimos repellendus eaque
      saepe, sequi optio nostrum sed cumque iste? Ad doloribus voluptate
      consectetur aliquam nesciunt? Doloribus, voluptatibus iure, dignissimos
      explicabo reprehenderit cupiditate veritatis aperiam quis unde expedita
      rerum consectetur soluta nostrum hic aut natus quas eum tempore id,
      dolorum incidunt nisi dolore. Modi earum voluptatem culpa vero
      consequuntur voluptatibus ducimus asperiores tenetur, fugiat maiores illo
      repellat quidem eum aperiam esse voluptates voluptas rerum dolor mollitia
      nam, iste harum sequi ratione hic! Ducimus blanditiis sunt nihil iure
      consectetur modi enim quis pariatur, obcaecati, eum facere non laboriosam
      quo magni magnam, ab ratione molestiae in repellat. Doloribus suscipit
      distinctio velit delectus quaerat deleniti dolores pariatur architecto
      animi ipsam excepturi, soluta quae eligendi autem voluptas cupiditate
      voluptate necessitatibus impedit. Repellendus nam quod cupiditate ea?
      Exercitationem vero aperiam similique voluptatibus non distinctio
      explicabo sint minima, excepturi eaque sapiente quos saepe perferendis.
      Velit fugit numquam corrupti quod consequuntur vel, qui et debitis
      voluptates, ducimus neque eum dolore nihil molestias veritatis? Unde
      debitis accusantium repellendus quos totam repudiandae, recusandae, qui
      inventore, non voluptatem quo at ullam quidem! Laudantium, repellat
      laboriosam. Sint, eum nostrum? Nemo, consequatur. Doloribus similique
      corporis sed quaerat id deleniti incidunt accusamus error tenetur quis
      eligendi tempore modi atque natus labore eum, dolore consequuntur fugit
      accusantium. Soluta repellendus incidunt qui tempora facilis laborum nam
      optio. Sapiente sit ab adipisci minima pariatur nulla accusamus,
      consequuntur illum dolore provident ratione, beatae blanditiis totam
      fugiat. Nostrum totam fugit dolorem assumenda explicabo et impedit,
      inventore qui at amet doloremque enim facilis nobis aut facere asperiores
      maxime quo veritatis consectetur nulla ex odio labore earum? Veritatis quo
      iste recusandae libero rerum eius, quaerat iure, aut maiores nulla
      similique sequi dolores sunt eligendi numquam. Doloribus ullam labore sunt
      quasi officiis nemo est officia possimus nesciunt facilis? Esse nisi
      molestias consequatur maxime cupiditate? Doloremque ab suscipit placeat
      harum, delectus fugit in voluptatibus dignissimos dicta aliquam
      perferendis soluta quibusdam exercitationem obcaecati, doloribus vitae
      quasi enim eum quis! Architecto iusto delectus commodi voluptatem
      accusamus modi suscipit, neque temporibus asperiores ut saepe cupiditate
      in molestiae quas assumenda eum amet odit ducimus aspernatur ratione cum
      nobis sequi quasi odio. Nihil aliquam quos voluptas, exercitationem
      voluptates repellendus placeat laudantium, officia aperiam suscipit
      nesciunt id? Earum repellendus voluptatibus laboriosam, adipisci delectus
      sint voluptate et eius voluptas debitis? Esse numquam, dolorum deleniti
      necessitatibus quae rerum reprehenderit nemo officiis, iusto vitae alias
      saepe excepturi reiciendis. Eligendi non modi voluptatem? Sapiente quas,
      dicta nesciunt beatae mollitia nisi dolorum consequatur, saepe ratione,
      neque voluptates minus rem expedita laudantium ipsum cum. Veniam tenetur
      iste assumenda ad eum officia deleniti, porro sit nostrum cupiditate,
      molestias labore? Repellendus, quis, quod dicta sequi voluptates laborum
      hic veniam consectetur consequatur, labore voluptate consequuntur
      inventore voluptatum animi esse tempora! Recusandae beatae, rem porro quam
      provident voluptatum vitae enim sed distinctio ratione ex, est amet
      asperiores. Corporis repellendus facere in facilis reiciendis aperiam
      nobis iusto animi quod quia similique vel, doloribus inventore nam ab
      maiores officia autem porro, atque mollitia, nulla neque ea. Aliquid
      magnam asperiores deleniti aspernatur recusandae soluta.
    </div>
    <page-footer />
  </div>
</template>

<style lang="scss" scoped>
.box {
  padding: 210px;
  background-color: #fff;
}

.items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .item {
    width: 510px;
    height: 340px;
    cursor: pointer;
    background: #f8f8f8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 70px;
    transition: all 0.3s ease-in-out;
    &:nth-of-type(2n) {
      margin-left: 70px;
    }

    &:hover {
      background: rgba($color: #ddd, $alpha: 0.5);
    }

    &-thumb {
      margin-bottom: 32px;
    }

    &-img {
      width: 80px;
    }

    &-title {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 700;
      font-size: 25px;
      line-height: 29px;

      color: #3f3f3f;
    }
  }
}
</style>

<script>
import PageFooter from "../components/PageFooter.vue";
import PageHeader from "../components/PageHeaderV2.vue";

import { mapGetters } from "vuex";

export default {
  name: "About",
  computed: {
    ...mapGetters(["getPageData"]),
    banner() {
      let key = "service";
      let page = this.getPageData;
      return !!page[key] ? page[key] : false;
    },
  },

  methods: {
    goItem(item) {
      if (!!item.url) {
        window.location.href = url;
      }
    },
  },
  data() {
    return {
      items: [
        {
          id: 1,
          thumb: "//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/i1.png",
          title: "About Us",
        },
        {
          id: 2,
          thumb: "//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/i2.png",
          title: "Shop Online",
        },
        {
          id: 3,
          thumb: "//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/i3.png",
          title: "Call Us",
        },
        {
          id: 4,
          thumb: "//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/i4.png",
          title: "E-mail Us",
        },
        {
          id: 5,
          thumb: "//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/i5.png",
          title: "News",
        },
        {
          id: 6,
          thumb: "//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/i6.png",
          title: "Show Room",
        },
      ],
    };
  },
  components: {
    PageFooter,

    PageHeader,
  },
};
</script>
